import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const USERS = [{
  name: 'Juan M.',
  city: 'Buenos Aires',
  img: 'https://randomuser.me/api/portraits/men/22.jpg'
}, {
  name: 'Sofía L.',
  city: 'Córdoba',
  img: 'https://randomuser.me/api/portraits/women/33.jpg'
}, {
  name: 'Martín P.',
  city: 'Rosario',
  img: 'https://randomuser.me/api/portraits/men/45.jpg'
}, {
  name: 'Ana R.',
  city: 'Mendoza',
  img: 'https://randomuser.me/api/portraits/women/55.jpg'
}, {
  name: 'Federico G.',
  city: 'La Plata',
  img: 'https://randomuser.me/api/portraits/men/67.jpg'
}, {
  name: 'Lucía D.',
  city: 'Tucumán',
  img: 'https://randomuser.me/api/portraits/women/12.jpg'
}];
export function SocialProofPopup() {
  const [currentUser, setCurrentUser] = useState<(typeof USERS)[0] | null>(null);
  useEffect(() => {
    const scheduleNextPopup = () => {
      // Random interval between 20s and 35s
      const delay = Math.floor(Math.random() * (35000 - 20000 + 1) + 20000);
      setTimeout(() => {
        const randomUser = USERS[Math.floor(Math.random() * USERS.length)];
        setCurrentUser(randomUser);
        // Hide after 5 seconds
        setTimeout(() => {
          setCurrentUser(null);
          scheduleNextPopup();
        }, 5000);
      }, delay);
    };
    scheduleNextPopup();
    return () => {
      // Cleanup handled by unmount
    };
  }, []);
  return <AnimatePresence data-id="element-28">
      {currentUser && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} className="fixed bottom-6 left-6 z-50 bg-white rounded-lg shadow-2xl border border-[#E2DED6] p-4 max-w-sm flex items-center gap-4" data-id="element-29">
          <button onClick={() => setCurrentUser(null)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" aria-label="Cerrar" data-id="element-30">
            <X size={14} data-id="element-31" />
          </button>

          <img src={currentUser.img} alt={currentUser.name} className="w-12 h-12 rounded-full object-cover border-2 border-[#586880]" data-id="element-32" />

          <div data-id="element-33">
            <p className="text-sm text-[#424E60] font-medium pr-4" data-id="element-34">
              <span className="font-bold" data-id="element-35">{currentUser.name}</span> de{' '}
              {currentUser.city} acaba de adquirir el Manual Académico
            </p>
            <div className="flex items-center gap-1 mt-1 text-xs text-green-600 font-bold" data-id="element-36">
              <CheckCircle2 size={12} data-id="element-37" />
              <span data-id="element-38">Compra verificada</span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}